import api from './api';

const UserService = {
  // Set user profile picture
  setProfilePicture: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.patch('/users/profile-picture', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete user profile picture
  deleteProfilePicture: async () => {
    const response = await api.delete('/users/profile-picture');
    return response.data;
  },

  updatePhone: async (phone) => {
    const response = await api.put('/users/phone', { phone });
    return response.data;
  },
};

export default UserService;

